import React from 'react';
import Link from 'next/link';
import { ChevronLeft } from 'lucide-react';

interface Props {
  showBackLink?: boolean;
}

export const Header: React.FC<Props> = ({ showBackLink = false }) => (
  <header className="flex items-center justify-between px-6 h-header bg-bg-raised border-b border-border flex-shrink-0">
    <a
      href="#main-content"
      className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-[10px] focus:z-[200] focus:bg-bg-panel focus:text-accent focus:border focus:border-accent focus:px-3 focus:py-[5px] focus:rounded-sm focus:text-[11px] focus:tracking-[0.04em]"
    >
      Skip to content
    </a>
    <Link
      href="/"
      className="text-[1rem] font-bold tracking-[0.18em] uppercase text-text-primary hover:text-accent transition-colors"
    >
      Brecha
    </Link>
    <div className="flex items-center gap-4">
      <Link
        href="/about"
        className="hidden desk:inline text-[11px] text-text-muted hover:text-text-secondary transition-colors tracking-[0.04em]"
      >
        How it works
      </Link>
      {showBackLink && (
        <Link
          href="/"
          className="inline-flex items-center gap-[3px] text-[0.8125rem] text-text-secondary hover:text-text-primary transition-colors no-underline"
          aria-label="Back to home"
        >
          <ChevronLeft size={14} aria-hidden="true" /> Back
        </Link>
      )}
    </div>
  </header>
);
